(function () {
  if (window.__eolCartQuickAddBound) {
    return;
  }
  window.__eolCartQuickAddBound = true;

  function getCartUrls() {
    var urls = window.EOL_CART_URLS || {};
    return {
      add: urls.add || '/cart/add.js',
      cart: urls.cart || '/cart'
    };
  }

  function rebindCartControls() {
    var configElement = document.getElementById('cart-config');
    var ajaxCart = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;

    if (!configElement || !ajaxCart || typeof ajaxCart.cartEvents !== 'function') {
      return;
    }

    try {
      ajaxCart.cartEvents(JSON.parse(configElement.textContent || '{}'));
    } catch (e) {
      /* Keep the refreshed cart usable if the theme config cannot be read. */
    }
  }

  function syncCartCount() {
    var urls = getCartUrls();
    var cartJsonUrl = urls.cart.replace(/\/+$/, '') + '.js?t=' + Date.now();

    return fetch(cartJsonUrl, {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.js-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {
        /* Keep the refreshed cart usable if the count request fails. */
      });
  }

  function refreshCartContent() {
    var urls = getCartUrls();
    var ajaxCartUrl = urls.cart.replace(/\/+$/, '') + '?view=ajax';

    return fetch(ajaxCartUrl, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var contentTemplate = doc.querySelector('template[data-html="content"]');
        var newHtml = contentTemplate ? contentTemplate.innerHTML : '';

        if (newHtml) {
          document.querySelectorAll('.js-ajax-cart-content').forEach(function (el) {
            el.innerHTML = newHtml;
          });
          rebindCartControls();
        }

        var optionsTemplate = doc.querySelector('template[data-options]');
        if (optionsTemplate) {
          try {
            var opts = JSON.parse(optionsTemplate.textContent);
            if (typeof opts.item_count !== 'undefined') {
              document.querySelectorAll('.js-cart-count').forEach(function (el) {
                el.textContent = opts.item_count;
              });
            }
          } catch (e) {
            /* ignore parse errors */
          }
        }
      })
      .then(syncCartCount);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-cart-quick-add-btn, .js-grid-add-to-cart-btn') : null;
    if (!btn) {
      return;
    }
    e.preventDefault();
    if (btn.disabled) {
      return;
    }

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      return;
    }

    var isGridButton = btn.classList.contains('js-grid-add-to-cart-btn');
    var urls = getCartUrls();
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(urls.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error((err && err.description) || 'Could not add that item to your cart.');
          });
        }
        return res.json();
      })
      .then(function () {
        return refreshCartContent();
      })
      .then(function () {
        btn.textContent = 'Added ✓';
        if (isGridButton) {
          var trigger = document.querySelector('.js-mini-cart-trigger');
          if (trigger) {
            trigger.click();
          }
        }
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 1500);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = originalText;
        window.alert(err.message || 'Sorry, something went wrong adding that item.');
      });
  });
})();
